export default [
  {
    path: '/protocol',
    name: 'protocol',
    component: () =>
      import(/* webpackChunkName: "Protocol" */ '@/views/protocol/Protocol.vue')
  }
];
